import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
// import { worker } from "./mocks/browser";
import { BrowserRouter } from "react-router-dom";

// if (import.meta.env.VITE_MSW === "test") {
//   worker.start();
// }

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
